import React, { useState } from "react";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { startCase } from "lodash";

const actorFields = ["ip", "city", "country", "source", "userId"];

const hasActorData = (actor) => actor && actorFields.some((field) => actor[field]);

const formatValue = (value) => {
  if (!value) return "-";
  if (typeof value === "object") {
    if (value.firstName || value.lastName) return [value.firstName, value.lastName].filter(Boolean).join(" ");
    if (value.email) return value.email;
    if (value._id) return value._id;
    return JSON.stringify(value);
  }
  return value;
};

const OriginActor = ({ title, actor, t }) => {
  if (!hasActorData(actor)) {
    return (
      <Col md="6" className="mb-3">
        <h6 className="fw-bold mb-2">{t(title)}</h6>
        <p className="text-muted mb-0">{t("No origin data")}</p>
      </Col>
    );
  }

  return (
    <Col md="6" className="mb-3">
      <h6 className="fw-bold mb-2">{t(title)}</h6>
      {actorFields.map((field) => (
        <div className="d-flex justify-content-between gap-3 mb-1" key={field}>
          <span className="fw-semibold">{t(startCase(field))}</span>
          <span className="text-muted text-end">{formatValue(actor[field])}</span>
        </div>
      ))}
    </Col>
  );
};

function OriginDetailsButton({ origin = {}, t }) {
  const [open, setOpen] = useState(false);
  const hasOrigin = hasActorData(origin?.requester) || hasActorData(origin?.approver);

  return (
    <>
      <Button
        type="button"
        color="link"
        className={`p-0 ${hasOrigin ? "text-success" : "text-muted"}`}
        disabled={!hasOrigin}
        title={t(hasOrigin ? "View origin details" : "No origin data")}
        onClick={() => setOpen(true)}
      >
        <i className="mdi mdi-map-marker-radius font-size-20" />
      </Button>
      <Modal isOpen={open} toggle={() => setOpen(false)} centered size="lg">
        <ModalHeader toggle={() => setOpen(false)} tag="h4">
          {t("Origin Details")}
        </ModalHeader>
        <ModalBody>
          <Row>
            <OriginActor title="Requester" actor={origin?.requester} t={t} />
            <OriginActor title="Approver" actor={origin?.approver} t={t} />
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
}

export default withTranslation()(OriginDetailsButton);
